import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/39_field/39_field"
 * Contains 1 texture(s)
 */
export class Tablet39FieldAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/39_field/39_field';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '39_field.jpg'
    ] as const;
}
